module.exports = __webpack_public_path__ + "static/media/a1.ac3f4c52.jpg";